import React from 'react';
import i18n from '../../../../i18n';
import { SideBar } from '../../sidebar';
import { SiteVisitRequestsTable } from './components/SiteVisitRequestsTable';
import NoData from '../../../common/NoData';
import { TableSkeleton } from '../../../common/skelton/TableSkelton';
import StatusTabs from '../../../common/StatusTab';
import HeaderBanner from '../../../common/HeaderBanner';
import { getLoggedUser } from '../../../../state/user';
import { getSiteVisitRequest } from './services/siteVisitRequestService';


export class SiteVisitRequests extends React.Component {
    constructor() {
        super();
        this.state = {
            search: {
                group: '',
                auction: '',
                status: '',
                bidder: null,
            },
            siteVisitStatus: 'all',
            input: {},
            groups: [],
            auctions: [],
            customers: [],
            siteVisits: [],
            selectedUser: {},
            showUserPopUp: false,
            statusData: [
                { label: 'All', count: 0 },
                { key: 'N', label: 'New', count: 0 },
                { key: 'scheduled', label: 'Scheduled', count: 0 },
                { key: 'completed', label: 'Completed', count: 0 },
                { key: 'cancelled', label: 'Cancelled', count: 0 },
            ],
            is_loading: false,
            limit: 15,
            page: 1,
            rejectNote: null,
            rejectNoteError: null,
            hideSidebar: false,
            showModal: false
        };

    }

    componentDidMount() {
        window.scrollTo(0, 0);
        const params = new URLSearchParams(window.location.search);
        const search = {
            group: params.get('group') || '',
            auction: params.get('auction') || '',
            status: params.get('status') || '',
            bidder: params.get('bidder') || null,
        };
        const siteVisitStatus = params.get('siteVisitStatus');
        const page = parseInt(params.get('page')) || 1;
        const limit = parseInt(params.get('limit')) || 15;

        this.setState({ search, siteVisitStatus, page, limit }, () => {
            this.getAllGroups?.();
            this.getSiteVisits();
        });
    }

    updateUrlQuery(q) {
        const queryString = new URLSearchParams(
            Object.fromEntries(Object.entries(q).filter(([_, v]) => v !== '' && v !== null))
        ).toString();
        window.history.replaceState(null, '', `${window.location.pathname}?${queryString}`);
    }

    async getSiteVisits() {
        this.setState({ is_loading: true });
        let { limit, page, siteVisitStatus } = this.state;
        let { status } = this.state.search;

        const q = {
            page: page,
            per_page: limit,
        };

        if (siteVisitStatus && siteVisitStatus !== "all") {
            q.status = siteVisitStatus;
        }

        if (status) q.status = status;

        this.updateUrlQuery(q);

        console.log('Fetching site visits with params:', q);

        let response = await getSiteVisitRequest(q);
        console.log('API Response:', response);

        if (response && response.status === true) {
            let siteVisits = response.data || [];
            let pagination = response.pagination;

            let { total, newCount, completedCount, trainingVisitCount, siteVisitCount } = response.meta;

            this.setState({
                siteVisits: siteVisits,
                total: pagination?.total || siteVisits.length,
                statusData: [
                    { key: 'all', label: 'All', count: total || 0 }, 
                    { key: 'N', label: 'New', count: newCount || 0 },
                    { key: 'WT', label: 'Waiting for Training', count: trainingVisitCount || 0 },
                    { key: 'WS', label: 'Waiting for Site Visit', count: siteVisitCount || 0 },
                    { key: 'C', label: 'Completed', count: completedCount || 0 },
                ],
                is_loading: false,
            });
        } else {
            console.error('Failed to fetch site visits:', response);
            this.setState({
                siteVisits: [],
                is_loading: false
            });
        }
    }


    handleTabChange = (key) => {
        this.setState({ siteVisitStatus: key }, () => {
            this.getSiteVisits();
        });
    };

    onChangePage = (page) => {
        this.setState({ page: page }, () => {
            this.getSiteVisits();
        });
    };

    onChangeRowsPerPage = (limit) => {
        this.setState({ limit: limit, page: 1 }, () => {
            this.getSiteVisits();
        });
    };


    render() {
        const user = getLoggedUser();

        return (
            <React.Fragment>
                <HeaderBanner
                    title={i18n.t('site_visit_management')}
                    subtitle={i18n.t('manage_site_visit_requests')}
                />
                <section className="mt-5">
                    <div className="container">
                        <div className="row">
                            <div className="col-xl-3 col-lg-12 col-md-12">
                                {!this.state.hideSidebar && <SideBar />}
                            </div>
                            <div
                                className={
                                    this.state.hideSidebar
                                        ? 'col-xl-12 col-lg-12 col-md-12'
                                        : 'col-xl-9 col-lg-12 col-md-12'
                                }
                            >
                                <div className="card">
                                    <div className="card-header">
                                        <div className="expand-dashboard">
                                            <span
                                                style={{ fontSize: '1rem', marginRight: '0.5rem', cursor: 'pointer' }}
                                                onClick={() => {
                                                    this.setState({
                                                        hideSidebar: !this.state.hideSidebar,
                                                    });
                                                }}
                                            >
                                                {this.state.hideSidebar && <i className="icon-size-actual"></i>}
                                                {!this.state.hideSidebar && <i className="icon-size-fullscreen"></i>}
                                            </span>
                                        </div>


                                    </div>
                                    <div className="card-body">
                                        <StatusTabs
                                            tabs={this.state.statusData}
                                            onTabChange={this.handleTabChange}
                                            selected={this.state.siteVisitStatus}
                                        />

                                        <div className="Data-Listing">
                                            {this.state.is_loading ? (
                                                <TableSkeleton columns={8} rows={10} />
                                            ) : this.state.siteVisits.length ? (
                                                <SiteVisitRequestsTable
                                                    siteVisits={this.state.siteVisits}
                                                    isLoading={this.state.is_loading}
                                                    pendingTab={this.state.siteVisitStatus === 'pending'}
                                                    currentPage={this.state.page}
                                                    limit={this.state.limit}
                                                    total={this.state.total}
                                                    onChangePage={this.onChangePage}
                                                    onChangeRowsPerPage={this.onChangeRowsPerPage}
                                                    showUserInfo={(user) => {
                                                        this.setState({
                                                            selectedUser: user,
                                                            showUserPopUp: true,
                                                        });
                                                    }}
                                                    userRole={user?.role}
                                                />
                                            ) : (
                                                <NoData
                                                    message="No site visits available"
                                                    actionText="Refresh"
                                                    onAction={this.getSiteVisits.bind(this)}
                                                />
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </section>

            </React.Fragment>
        );
    }
}
